module.exports = "<span *ngIf=\"value\">{{value.join(', ')}}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/display-array/display-array.component.html
// module id = 291
// module chunks = 0 1